// extracted by mini-css-extract-plugin
export var copyableField = "_rl-4";
export var customerBadge = "_rl-0";
export var customerInfoTitle = "_rl-2";
export var details = "_rl-1";
export var dropdownContainer = "_rl-5";
export var dropdownImage = "_rl-6";
export var editAssigneeForm = "_rl-a";
export var editButton = "_rl-3";
export var email = "_rl-7";
export var hidden = "_rl-d";
export var input = "_rl-8";
export var saveButton = "_rl-b";
export var shopifyIcon = "_rl-c";
export var suggestionBadge = "_rl-e";
export var suggestionText = "_rl-f";
export var username = "_rl-9";